import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {SafeResourceUrl} from '@angular/platform-browser';
import {GetTeamRoles} from '../../../services/team-role/GetTeamRoles';
import {GetUsers} from '../../../services/user/GetUsers';

@Component({
  selector: 'digires-team-member-details-dialog',
  templateUrl: './team-member-details-dialog.component.html',
  styleUrls: ['./team-member-details-dialog.component.scss']
})
export class TeamMemberDetailsDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      user: GetUsers,
      role: GetTeamRoles,
      userPicture: SafeResourceUrl,
      userPictureEnabled: boolean,
    },
  ) { }

}
